import { IboxplotDiagramData } from "types/sharedTypes"

function prepareBoxplotDiagramData(
    unpreparedData: any[],
    chartTitle: string,
    yAxisTitle: string
) {
    const preparedDiagramData: IboxplotDiagramData = {
        ChartTitle: chartTitle,
        YAxisTitle: yAxisTitle,
        Data: [],
        Categories: [],
    }

    const diagData: any[] = []

    unpreparedData.forEach((row) => {
        const result = typeof row === "string" ? JSON.parse(row) : row
        const item = result?.[0]

        if (!item) {
            console.log("⚠️ Invalid row in prepareBoxplotDiagramData:", row)
            return
        }

        const categories = item.Categories ?? item.categories ?? []

        // Din regel:
        // Om position 2 är null → ta position 1
        // annars ta position 2
        const rawName =
            categories[1] != null && categories[1] !== ""
                ? categories[1]
                : categories[0] ?? ""

        const name = String(rawName)

        diagData.push({
            Name: name,
            Data: item.Data ?? item.data ?? [],
        })
    })

    diagData.forEach((group, index) => {
        preparedDiagramData.Categories.push(group.Name)

        group.Data.forEach((arr: number[]) => {
            const newArr = [...arr]
            newArr.splice(0, 0, index)
            preparedDiagramData.Data.push(newArr)
        })
    })

    const sortedIndices = preparedDiagramData.Categories
        .map((category, index) => ({
            category: category ?? "",
            index,
        }))
        .sort((a, b) => String(a.category).localeCompare(String(b.category)))
        .map((item) => item.index)

    preparedDiagramData.Categories = sortedIndices.map(
        (i) => preparedDiagramData.Categories[i] ?? ""
    )

    preparedDiagramData.Data = sortedIndices.flatMap((sortedIndex) =>
        preparedDiagramData.Data
            .filter((data) => data[0] === sortedIndex)
            .map((data) => {
                const newData = [...data]
                newData[0] = sortedIndices.indexOf(sortedIndex)
                return newData
            })
    )

    preparedDiagramData.Data.forEach((d) => {
        d.sort((a, b) => a - b)
    })

    return preparedDiagramData
}

export default prepareBoxplotDiagramData